import React from 'react';
import { useParams } from 'react-router-dom';
import PaymentPending from '../components/payments/PaymentPending';

function PaymentPendingPage() {
    const { uid } = useParams(); // Token from URL
    return <PaymentPending token={uid} />;
}

export default PaymentPendingPage;
